/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import styles from '../styles/Home.module.css';
import loginStyles from '../styles/Login.module.css';
import { useEffect, useState } from 'react';
import { AttributeInputCallback, CallbackType, FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType, TokenManager } from '@forgerock/javascript-sdk';
import Loading from '../components/02-molecules/Loading';
import { trees } from '../config';
import { useNavigate } from 'react-router-dom';
import ErrorMessage from '../components/01-atoms/ErrorMessage';
import LoginForm from '../components/forms/Login/index';
import LoginFormMaintenance from '../components/forms/Login/indexMaintenance';
import LoginFormMaintenanceLogin from '../components/forms/Login/indexMaintenanceLogin';
import SelectMFAMethod from '../components/forms/Login/selectMFAMethod';
import RegisterAppQR from '../components/forms/Login/registerAppQR';
import ValidateCode from '../components/forms/common/ValidateCode';
import AcceptTermsAndConditions from '../components/forms/common/AcceptTermsAndConditions';
import { useAppDispatch } from '../redux/hooks';
import { setLoginRequested, toggleLogin,setMaintenanceEnabled,setMaintenanceMessage } from '../redux/loginSlice';
import { MessageType } from '../components/modals/SuccessErrorModal';
import AppAuthHelper from 'appauthhelper/appAuthHelperCompat';
import cloneDeep from 'lodash/cloneDeep';
import logo from '../images/pw-logo.png';
import { isNil } from 'lodash';


const tree = trees.login;

const LoginPage = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
  const [goto, setGoto] = useState('');
  const [messageType, setMessageType] = useState(MessageType.error);
  const [message, setMessage] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [redirectUI, setRedirectUI] = useState('')
  const [maintenancePage,setMaintenancePage] = useState(false)

  const redirectHandle = (initialStep: FRStep | FRLoginFailure | FRLoginSuccess) => {
    if (initialStep && initialStep.type === StepType.Step) {
      let email = ''
      const meta = initialStep.getCallbacksOfType(CallbackType.MetadataCallback)
      if (!!meta && meta.length) {
        email = (meta[0].getOutputValue('data') as any)['email'] as string;
      }
      initialStep.callbacks.forEach((callback, i) => {
        const type = callback.getType()
        if (type === CallbackType.RedirectCallback) {

          if (callback.getOutputValue('trackingCookie')) {
            // save current step information for later resumption of tree.
            sessionStorage.setItem('authIndexValue', tree);
            sessionStorage.setItem('step', JSON.stringify(initialStep));
            sessionStorage.setItem('realm', 'PnW');
            localStorage.setItem(FRAuth.previousStepKey, JSON.stringify(initialStep))
          }
          const redirectUrl = callback.getOutputValue('redirectUrl') as string;
          if (callback.getOutputValue('redirectMethod') === 'POST') {
            const redirectData = callback.getOutputValue('redirectData') as string;
            const form = document.createElement('form');
            form.method = 'post';
            //form.action = redirectUrl+'&login_hint='+email ;
            form.action = redirectUrl;            
            Object.entries(redirectData as string).forEach(([key, value]) => {
              const hiddenField = document.createElement('input');
              hiddenField.type = 'hidden';
              hiddenField.name = key;
              hiddenField.value = value;
              form.appendChild(hiddenField);
            });
            const loginHint = document.createElement('input');
            loginHint.type = 'hidden';
            loginHint.name = "login_hint";
            loginHint.value = email;
            form.appendChild(loginHint);
            document.body.appendChild(form);
            form.submit();
          } else {
            let loginHintRedirectURI = redirectUrl + '&login_hint=' + email
            let loginHintUrlStep = cloneDeep(initialStep);

            loginHintUrlStep.callbacks.map((callback) => {
              if (callback.getType() === CallbackType.RedirectCallback) {
                callback.payload.output.map((values) => {
                  if (values.name == "redirectUrl") {
                    values.value = loginHintRedirectURI;
                  }
                });
              }
            });
            FRAuth.redirect(loginHintUrlStep as FRStep);
          }
          return;
        }
      })
    }
  }



  useEffect(() => {
    (async function getStep() {

      setGoto(new URLSearchParams(window.location.search).get('goto') || '')
      let localGoto = new URLSearchParams(window.location.search).get('goto') || ''
      const stepString = sessionStorage.getItem('step')
      const code = sessionStorage.getItem('mfacode')
      const state = sessionStorage.getItem('mfastate')
      let step;
       if (!!stepString) {
         step = JSON.parse(stepString).payload;        
       }
      setRedirectUI(new URLSearchParams(window.location.search).get('redirectUi') || '')
       if (!!!step) {
        try {
          const initialStep = await FRAuth.start({ tree });
          setStep(initialStep);
        } catch (err) {
          setMaintenancePage(true)
          console.error(`Error: request for initial step; ${err}`);
        }
       } else {
         if (!!code && !!state) {
           let queryParam;
           if (!isNil(localGoto)) {
             queryParam = '&code=' + code + '&state=' + state + '&authIndexValue=' + tree
           } else {
             queryParam = '?code=' + code + '&state=' + state + '&authIndexValue=' + tree
           }  
          const nextStep = await FRAuth.resume(window.location.href + queryParam)
           setStep(nextStep);
         }

       }

    })();
  }, []);

  //  checks for when there is a login success, redirects to the landing page if it succeeds
  useEffect(() => {
    (async () => {
      if (step && step.type === StepType.LoginSuccess) {
        sessionStorage.removeItem('mfacode');
              sessionStorage.removeItem('mfastate');
              sessionStorage.removeItem('step');
        if (goto && goto != null && goto != '' && goto != undefined) {
          window.location.replace(goto)

        }
        else {

          if (redirectUI && redirectUI != null && redirectUI != '' && redirectUI != undefined) {
            // localStorage.clear();
            // sessionStorage.clear();
              
            //await TokenManager.getTokens();
            navigate(redirectUI)
          } else {
            // await TokenManager.getTokens();
            navigate('/dashboard');
          }
          dispatch(setLoginRequested(true))


        }
      }
    })();
  }, [step, navigate]);

  const setUpIntialStep = async (message: string) => {
    const initialStep = await FRAuth.start({ tree });
    setStep(initialStep);
    setIsAlertOpen(true);
    setMessage(message)

  }

  const getMaintenanceMessage = (step:FRStep) => {
    var maintenanceMessage:string = ""
    const validatePasswordCallBacks = step.getCallbacksOfType(CallbackType.TextOutputCallback)
    validatePasswordCallBacks.forEach((validatePasswordCallBack) => {
      const attributeInputCallback = new AttributeInputCallback(validatePasswordCallBack.payload)
      maintenanceMessage = attributeInputCallback.getOutputByName("message","No message available.")
    })

    return maintenanceMessage
  }

  const getLoginView = () => {
    let uiElement: JSX.Element = <Loading size={100} />;
    if(!maintenancePage){
      if (step && step.type === StepType.Step) {
        switch (step.getStage()) {
          case 'Login':
            dispatch(setMaintenanceEnabled(false))
            uiElement = <LoginForm step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} goto={goto} />
            break;
          case 'SelectMFA':
            uiElement = <SelectMFAMethod step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
            break;
          case 'RegisterApp':
            uiElement = <RegisterAppQR step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
            break;
          case 'CheckCodeEmail':
          case 'CheckCodeApp':
            uiElement = <ValidateCode step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
            break;
          case 'TermsAndConditions':
            uiElement = 
            <div style={{marginLeft:"-24px"}}>
              <div className={loginStyles.logoWrapperTnC}></div>
              <AcceptTermsAndConditions step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} /></div>
            break;
          case 'RedirectMFA':
            sessionStorage.setItem('step', JSON.stringify(step))
            sessionStorage.setItem('redirectOrgin', window.location.href)
            redirectHandle(step);
            break;
          case 'Maintenance':
            dispatch(setMaintenanceEnabled(true))
            dispatch(setMaintenanceMessage(getMaintenanceMessage(step)))
            uiElement = <LoginFormMaintenance step={step as FRStep} setStep={setStep}
            tree={tree} messageType={messageType} setMessageType={setMessageType}
            message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} goto={goto} />
          break;
          case 'MaintenanceLogin':
            dispatch(setMaintenanceEnabled(true))
            dispatch(setMaintenanceMessage(getMaintenanceMessage(step)))
            uiElement = <LoginFormMaintenanceLogin step={step as FRStep} setStep={setStep}
            tree={tree} messageType={messageType} setMessageType={setMessageType}
            message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} goto={goto} />
          break;
        }
      } else if (step && step.type === StepType.LoginFailure) {
        setUpIntialStep(step.payload.message || '');
      }
    } else {
      dispatch(setMaintenanceEnabled(true))
            dispatch(setMaintenanceMessage("Site under maintenance, please contact <a href='mailto:portalidentity@prattwhitney.com'>portalidentity@prattwhitney.com</a> for support."))
            uiElement = <LoginFormMaintenance step={step as FRStep} setStep={setStep}
            tree={tree} messageType={messageType} setMessageType={setMessageType}
            message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} goto={goto} />
    }
    return uiElement;
  }

  /*************render************************** */

  return (
    <div className={`${loginStyles.backgroundImage} ${styles.container}`} >
      {/* <main className={styles.main}> */}
      <main className={loginStyles.mainStylesLogin}>
        {getLoginView()}
      </main>
    </div>
  );
};

export default LoginPage;
